import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { routes } from '@const/routes';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import { useAmlCases } from '@hooks/api/useAmlCases';
import { Icon } from '@components/icons';
import { useBack } from '@hooks/helpers/useBack';
import { useGlobalContext } from '@hooks/context/useGlobalContext';
import DataInfo from '@components/data_info';
import FormField from '@components/form_field';
import Input from '@components/common/input';
import { useForm } from '@hooks/helpers/useForm';
import moment from 'moment/moment';

const AmlCaseLayout = () => {
    const { id } = useParams<{ id: string }>();
    const { handleNavigateBack } = useBack();
    const { handleChangeBackLabel } = useGlobalContext();
    const form = useForm({});

    const { amlCase } = useAmlCases({ isInitialCase: true });

    useEffect(() => {
        handleChangeBackLabel({ label: 'AML Cases', route: routes.aml_cases });
        return () => {
            handleChangeBackLabel({ label: '', route: '' });
        };
    }, [id]);

    useEffect(() => {
        if (amlCase) {
            form.reset({
                id: amlCase.id,
                re_id: amlCase.re_id || '',
                party_id: amlCase.party_id || '',
                status: amlCase.status || '',
                case_type: amlCase.case_type || '',
                alert_count: String(amlCase.alert_count),
                overdue: amlCase.overdue ? 'Yes' : 'No',
                opened_at: amlCase.opened_at
                    ? moment(amlCase.opened_at).format('MM.DD.YYYY HH:mm:ss')
                    : '',
                closed_at: amlCase.closed_at
                    ? moment(amlCase.closed_at).format('MM.DD.YYYY HH:mm:ss')
                    : '',
                due_at: amlCase.due_at
                    ? moment(amlCase.due_at).format('MM.DD.YYYY HH:mm:ss')
                    : ''
            });
        }
    }, [amlCase]);

    return (
        <div className={styles.wrapper}>
            <button onClick={handleNavigateBack} className="back">
                <Icon name="arrow_left" width={16} height={16} />
                Back
            </button>
            <div className={styles.header}>
                <div className={styles.text_wrapper}>
                    <Typography variant="h4">AML Case</Typography>
                </div>
            </div>
            <div className={styles.content}>
                <DataInfo label="Case Information" form={form}>
                    <FormField
                        name="id"
                        renderComponent={(props) => <Input readOnly full {...props} label="ID" />}
                    />
                    <FormField
                        name="re_id"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="RE ID" />
                        )}
                    />
                    <FormField
                        name="party_id"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Party ID" />
                        )}
                    />
                    <FormField
                        name="status"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Status" />
                        )}
                    />
                    <FormField
                        name="case_type"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Case Type" />
                        )}
                    />
                    <FormField
                        name="alert_count"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Alert Count" />
                        )}
                    />
                    <FormField
                        name="overdue"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Overdue" />
                        )}
                    />
                    <FormField
                        name="opened_at"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Opened" />
                        )}
                    />
                    <FormField
                        name="closed_at"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Closed" />
                        )}
                    />
                    <FormField
                        name="due_at"
                        renderComponent={(props) => (
                            <Input readOnly full {...props} label="Due" />
                        )}
                    />
                </DataInfo>
            </div>
        </div>
    );
};

export default AmlCaseLayout;
